"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var React = require("react");
var tooltip_1 = require("wix-ui-core/tooltip");
var Tooltip_st_css_1 = require("./Tooltip.st.css");
var Arrows_1 = require("./Arrows");
var TooltipEnums_1 = require("./TooltipEnums");
function customArrow(placement, arrowProps) {
    var ArrowSvg = Arrows_1.getArrowByPlacement(placement);
    return (React.createElement("div", __assign({ className: Tooltip_st_css_1.default.tpaArrow }, arrowProps),
        React.createElement(ArrowSvg, null)));
}
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        return (React.createElement(tooltip_1.Tooltip, __assign({}, Tooltip_st_css_1.default('root', { skin: this.props.skin }, this.props), this.props, { timeout: { enter: 120, exit: 80 }, customArrow: customArrow })));
    };
    Tooltip.displayName = 'Tooltip';
    Tooltip.defaultProps = {
        skin: TooltipEnums_1.TooltipSkin.Standard,
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map